import React from "react";

const VerticalPartition = () => {
    return (
        <svg width="25" height="94" viewBox="0 0 25 94" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="18" y="94" width="94" height="7" rx="3.5" transform="rotate(-90 18 94)" fill="#4A5353" />
            <rect x="7" y="94" width="94" height="11" rx="5.5" transform="rotate(-90 7 94)" fill="#B5C6C7" />
            <rect y="94" width="94" height="7" rx="3.5" transform="rotate(-90 0 94)" fill="#4A5353" />
        </svg>
    )
}
export default VerticalPartition;